export default __webpack_public_path__ + "static/media/logo.29350cf9.png";